import {
    ADD_MULTIPLE_CUSTOMER_IDS,
    CLEAR_CUSTOMER_DATA,
    CLEAR_STATE,
    EDIT_CUSTOMER_ID_SELECTION,
    EDIT_ITEM_QUANTITY,
    EDIT_SELECTED_QUANTITY,
    REMOVE_MULTIPLE_CUSTOMER_IDS,
    SELECT_MULTIPLE_CHOICE,
    SET_IGNORE_PAYMENT_STEP,
    SET_PAYMENT_NOTE,
    SET_PAYMENT_TYPE,
    SET_USE_CARD_ON_FILE,
    TOGGLE_OPTIONAL_ITEM,
    UPDATE_TOTALS
} from "./selectionActionTypes"
import {AppContext, Features} from "@lightspeed-invoicing/core-client/frontend"

export type SelectionStore = {
    customerIdSelection: Set<string>
    optionalItemSelection: string[]
    itemQuantities: ItemQuantitiesSelection[]
    multiChoiceItemSelection: string[]
    simulate: boolean
    ignorePaymentStep: boolean
    paymentType: string
    paymentNote: string
    useDefaultCardOnFile: boolean
    subtotal: number
    total: number
}

export type ItemQuantitiesSelection = {
    itemId: string
    measure: string
}

const defaultState: SelectionStore = {
    customerIdSelection: new Set(),
    optionalItemSelection: [],
    itemQuantities: [],
    multiChoiceItemSelection: [],
    ignorePaymentStep: false,
    paymentType: "",
    paymentNote: "",
    useDefaultCardOnFile: AppContext.hasFeatureIntegration(Features.IntegratedPayment),
    simulate: true,
    subtotal: 0,
    total: 0,
}

function selectionReducer(state = defaultState, action) {
    switch (action.type) {
    case EDIT_CUSTOMER_ID_SELECTION:
        if (!state.customerIdSelection.has(action.payload.id)) {
            state.customerIdSelection.add(action.payload.id)
        } else {
            state.customerIdSelection.delete(action.payload.id)
        }
        return { ...state }

    case CLEAR_CUSTOMER_DATA:
        state.customerIdSelection = new Set<string>()
        return { ...state }

    case TOGGLE_OPTIONAL_ITEM:
        if (state.optionalItemSelection.includes(action.payload.id)) {
            state.optionalItemSelection = state.optionalItemSelection.filter(id => id !== action.payload.id)
        } else {
            state.optionalItemSelection.push(action.payload.id)
        }
        state.optionalItemSelection = [...state.optionalItemSelection]
        return { ...state }

    case SELECT_MULTIPLE_CHOICE:
        state.multiChoiceItemSelection = state.multiChoiceItemSelection.filter(id => !action.payload.idsFromGroup.includes(id))
        if (!state.multiChoiceItemSelection.includes(action.payload.id)) {
            state.multiChoiceItemSelection.push(action.payload.id)
        }
        state.multiChoiceItemSelection = [...state.multiChoiceItemSelection]
        return { ...state }

    case EDIT_ITEM_QUANTITY:
        state.itemQuantities = state.itemQuantities.filter(item => item.itemId !== action.payload.itemId)
        state.itemQuantities = [...state.itemQuantities, action.payload]
        return { ...state }

    case EDIT_SELECTED_QUANTITY:
        const id = action.payload.itemIds.find(id => state.multiChoiceItemSelection.includes(id))
        state.itemQuantities = state.itemQuantities.filter(item => item.itemId !== id)
        state.itemQuantities = [...state.itemQuantities, {
            itemId: id,
            measure: action.payload.measure
        }]
        return { ...state }

    case UPDATE_TOTALS:
        state.subtotal = action.payload.subtotal
        state.total = action.payload.total
        return { ...state }

    case ADD_MULTIPLE_CUSTOMER_IDS:
        for (const id of action.payload.ids) {
            state.customerIdSelection.add(id)
        }
        return { ...state }

    case REMOVE_MULTIPLE_CUSTOMER_IDS:
        for (const id of action.payload.ids) {
            state.customerIdSelection.delete(id)
        }
        return { ...state }

    case CLEAR_STATE:
        return defaultState

    case SET_USE_CARD_ON_FILE:
        state.useDefaultCardOnFile = action.payload.useDefaultCardOnFile
        return { ...state }

    case SET_PAYMENT_TYPE:
        state.paymentType = action.payload.paymentType
        return { ...state }

    case SET_PAYMENT_NOTE:
        state.paymentNote = action.payload.paymentNote
        return { ...state }
    case SET_IGNORE_PAYMENT_STEP:
        state.ignorePaymentStep = action.payload.ignorePaymentStep
        return { ...state }
    default:
        return state
    }
}

export default selectionReducer


// WEBPACK FOOTER //
// ./src/state/selection/selectionReducer.ts